import { PermissionType } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { Col, Row } from 'antd';
import CreateClientButton from 'client/modules/external-api/components/CreateClientButton';
import { ClientDetail } from 'client/modules/external-api/components/ExternalApiPage';
import { useListTeamClients } from 'client/modules/external-api/hooks/queries/external-api';
import { externalApiPermissions } from 'client/modules/external-api/permissions';
import useHasAccess from 'client/utils/permissions-validation/hooks/useHasAccess';
import React from 'react';

type Props = {
  idTeam: number;
  name: string;
};

const ExternalApiClients = ({ idTeam, name }: Props) => {
  const hasAccessToExternalApiClients = useHasAccess({
    pageId: externalApiPermissions.pageId,
    permissionType: PermissionType.PUBLISH,
  });

  const { data: response, isFetching } = useListTeamClients(idTeam);

  const initialCredits = response?.clients[0]?.available_credits || 0;

  if (!hasAccessToExternalApiClients) {
    return (
      <div className="text-center">
        You do not have permission to view this tab.
      </div>
    );
  }

  if (!isFetching && response?.clients.length === 0) {
    return (
      <Row>
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xxl={{ span: 10 }}
        >
          <div>
            <CreateClientButton
              key={idTeam}
              idTeam={idTeam}
              name={name}
              initialCredits={parseInt(String(initialCredits), 10)}
            />
          </div>
          <p className="font-medium">No existing client.</p>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col
        xs={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 12 }}
        xxl={{ span: 10 }}
      >
        <div>
          <div className="ml-auto w-fit">
            <CreateClientButton
              key={idTeam}
              idTeam={idTeam}
              name={name}
              initialCredits={parseInt(String(initialCredits), 10)}
            />
          </div>
        </div>
        <ClientDetail response={response} isFetching={isFetching} />
      </Col>
    </Row>
  );
};

export default ExternalApiClients;
